<template>
  <div class="building-form-container animated fadeInRight">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('buildingForm.search.title') }}</span>
        <el-button type="text" style="float: right; padding: 3px 0" @click="_moreCondition">
          {{ buildingFormInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="buildingFormInfo.conditions.buildingName"
            :placeholder="$t('buildingForm.search.buildingName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="buildingFormInfo.conditions.userName"
            :placeholder="$t('buildingForm.search.userName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="buildingFormInfo.conditions.userTel"
            :placeholder="$t('buildingForm.search.userTel')" clearable />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="_queryBuildingFormMethod">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
          <el-button @click="_resetBuildingFormMethod">
            <i class="el-icon-refresh"></i>
            {{ $t('common.reset') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('buildingForm.list.title') }}</span>
        <!--<el-button type="primary" size="small" @click="_openAddBuildingFormModal">-->
        <!--  <i class="el-icon-plus"></i>-->
        <!--  {{ $t('common.add') }}-->
        <!--</el-button>-->
      </div>
      <el-table :data="buildingFormInfo.forms" border style="width: 100%">
        <el-table-column prop="id" :label="$t('buildingForm.table.id')" align="center" />
        <el-table-column prop="buildingName" :label="$t('buildingForm.table.buildingName')" align="center" />
        <el-table-column prop="userName" :label="$t('buildingForm.table.userName')" align="center" />
        <el-table-column prop="userTel" :label="$t('buildingForm.table.userTel')" align="center" />
        <el-table-column prop="createTime" :label="$t('buildingForm.table.createTime')" align="center" />
        <!--<el-table-column :label="$t('common.operation')" align="center" width="200">-->
        <!--  <template slot-scope="scope">-->
        <!--    <el-button size="mini" @click="_openEditBuildingFormModel(scope.row)">-->
        <!--      {{ $t('common.edit') }}-->
        <!--    </el-button>-->
        <!--    <el-button size="mini" type="danger" @click="_openDeleteBuildingFormModel(scope.row)">-->
        <!--      {{ $t('common.delete') }}-->
        <!--    </el-button>-->
        <!--  </template>-->
        <!--</el-table-column>-->
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top:20px;text-align:right" />
    </el-card>

    <add-building-form ref="addBuildingForm" @success="handleSuccess" />
    <edit-building-form ref="editBuildingForm" @success="handleSuccess" />
    <delete-building-form ref="deleteBuildingForm" @success="handleSuccess" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listBuildingForms } from '@/api/oa/buildingFormApi'
import AddBuildingForm from '@/components/oa/addBuildingFormView'
import EditBuildingForm from '@/components/oa/editBuildingFormView'
import DeleteBuildingForm from '@/components/oa/deleteBuildingForm'

export default {
  name: 'BuildingFormList',
  components: {
    AddBuildingForm,
    EditBuildingForm,
    DeleteBuildingForm
  },
  data() {
    return {
      buildingFormInfo: {
        forms: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          buildingName: '',
          userName: '',
          userTel: '',
          page: 1,
          row: 10,
          communityId: ''
        }
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.buildingFormInfo.conditions.communityId = this.communityId
    this._listBuildingForms()
  },
  methods: {
    async _listBuildingForms() {
      try {
        const params = {
          ...this.buildingFormInfo.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listBuildingForms(params)
        this.buildingFormInfo.forms = data
        this.page.total = total
      } catch (error) {
        console.error('获取房产留资列表失败:', error)
      }
    },
    _openAddBuildingFormModal() {
      this.$refs.addBuildingForm.open()
    },
    _openEditBuildingFormModel(row) {
      this.$refs.editBuildingForm.open(row)
    },
    _openDeleteBuildingFormModel(row) {
      this.$refs.deleteBuildingForm.open(row)
    },
    _queryBuildingFormMethod() {
      this.page.current = 1
      this._listBuildingForms()
    },
    _resetBuildingFormMethod() {
      this.buildingFormInfo.conditions = {
        buildingName: '',
        userName: '',
        userTel: '',
        page: 1,
        row: 10,
        communityId: this.communityId
      }
      this._listBuildingForms()
    },
    _moreCondition() {
      this.buildingFormInfo.moreCondition = !this.buildingFormInfo.moreCondition
    },
    handleSuccess() {
      this._listBuildingForms()
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listBuildingForms()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listBuildingForms()
    }
  }
}
</script>

<style lang="scss" scoped>
.building-form-container {
  padding: 20px;

  .box-card {
    margin-bottom: 20px;
  }

  .no_display {
    display: none;
  }
}
</style>